(function (c2, $) {
  "use strict";

  /* ── Orders/Requests dashboard widget (CMP-4067 phase 4) ──
   *
   * A server-side c2 DataTable of the viewer's needs-attention orders. The
   * Actions column is a btn-group of gated buttons carrying data-action-url
   * (a v3 order endpoint: approve/deny/cancel/remind/resume). Clicking one
   * POSTs to that endpoint and reloads the table so the row reflects the new
   * state. (The View action is a plain link, handled by the browser.)
   */

  function postAction(url, csrfToken) {
    return $.ajax({
      url: url,
      type: "POST",
      dataType: "json",
      headers: csrfToken ? { "X-CSRFToken": csrfToken } : {},
    });
  }

  function init(selector, opts) {
    opts = opts || {};
    var $table = $(selector);
    if (!$table.length || !c2.dataTables) {
      return;
    }

    // Show 5 rows per page (5 isn't in the c2 default lengthMenu). Server-side
    // via data-table-source; the JSON view applies search/sort/paging.
    c2.dataTables.init(selector, {
      pageLength: 5,
      lengthMenu: [5, 10, 25, 50],
    });

    // Delegated row actions (rows are re-rendered each draw).
    $table.on("click", ".ord-action", function () {
      var $btn = $(this);
      var url = $btn.data("action-url");
      var name = $btn.data("action-name") || "update";
      if (!url) {
        return;
      }
      $btn.prop("disabled", true);
      postAction(url, opts.csrfToken)
        .done(function () {
          $table.DataTable().ajax.reload(null, false);
        })
        .fail(function () {
          $btn.prop("disabled", false);
          if (c2.alerts) {
            c2.alerts.addGlobalAlert(
              "Could not " + name + " the order.",
              "error",
              true,
              5000,
            );
          }
        });
    });
  }

  c2.dashboardOrders = { init: init };
})(window.c2, window.jQuery);
